module.exports = __webpack_public_path__ + "img/elephant.71ca8cf0.jpeg";